export interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    id: '1',
    question: 'Ist die kosmetische Zahnaufhellung schmerzhaft?',
    answer: 'Nein — unsere Anwendung ist vollständig schmerzfrei. Wir arbeiten ausschließlich mit PAP-Technologie (Phthalimidoperoxycaproic Acid), die ohne Peroxid auskommt und die Zahnsubstanz schont. Du kannst dich während der Anwendung entspannen.',
  },
  {
    id: '2',
    question: 'Wie lange hält das Ergebnis?',
    answer: 'Das Ergebnis hält in der Regel 3–6 Monate, abhängig von deinen persönlichen Essgewohnheiten und der Zahnpflege. Mit einem regelmäßigen Fresh-Up alle 3 Monate kannst du dein strahlendes Lächeln dauerhaft erhalten.',
  },
  {
    id: '3',
    question: 'Ist die Anwendung sicher?',
    answer: 'Ja, absolut. Wir arbeiten nach der EU-Kosmetikverordnung (EG) Nr. 1223/2009 und verwenden ausschließlich zugelassene, peroxidfreie Produkte. Die PAP-Technologie ist klinisch getestet und gilt als eine der sichersten Methoden zur kosmetischen Zahnaufhellung.',
  },
  {
    id: '4',
    question: 'Was kostet die kosmetische Zahnaufhellung?',
    answer: 'Unsere Anwendungen beginnen ab 99€ für den Smile Starter (30 Min.) und reichen bis 199€ für das Smile Premium (60 Min.). Alle Preise sind transparent und inklusive aller verwendeten Materialien. Auf der Leistungsseite findest du eine detaillierte Übersicht.',
  },
  {
    id: '5',
    question: 'Was ist der Unterschied zum Zahnarzt?',
    answer: 'Wir bieten ausschließlich kosmetische Zahnaufhellung an — das ist eine rein ästhetische Anwendung, keine medizinische Behandlung. Zahnärzte arbeiten mit höher konzentrierten Wirkstoffen und führen medizinische Aufhellungsanwendungen durch. Beide Angebote ergänzen sich. Wir empfehlen vor jeder kosmetischen Aufhellung einen Zahnarztbesuch zur Kontrolle deiner Zahngesundheit.',
  },
  {
    id: '6',
    question: 'Wie viel heller werden meine Zähne?',
    answer: 'Das Ergebnis ist individuell verschieden. Im persönlichen Beratungsgespräch besprechen wir transparent, was bei dir realistisch erreichbar ist.',
  },
];
